import gql from 'graphql-tag';

const updateMajorsMessaging = gql`
  mutation updateMajorsMessaging($input: updateAMMessageMajorsInput!) {
    updateAMMessageMajors(input: $input) {
      messages {
        scid
        id
        version
        majors {
          enabled
          categoryId
          category
          messageOption
          defaultMessage
          messages {
            majorId
            major
            message
          }
        }
      }
    }
  }
`;

export default updateMajorsMessaging;
